<template>
  <DefaultLayout>
    <div slot="content">
      <!-- FEATURE LIMITED DIALOG-->
      <v-dialog v-model="featureLimitedModal" width="400" persistent>
        <v-card>
          <v-card-title>Feature limited</v-card-title>
          <v-card-text>{{featureLimitedText || featureLimitedDefaultText}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="featureLimitedModal = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END FEATURE LIMITED DIALOG-->
      <div class="d-flex align-center py-3">
        <div class="title">Account Email Templates</div>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" hide-details class="mt-0 mr-3"></v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" fab dark small color="green" @click="addTemplate"><v-icon dark>add</v-icon></v-btn>
          </template>
          <span>Create New {{ emailTemplatesTabs ? 'Custom' : 'Default' }} Template</span>
        </v-tooltip>
      </div>
      <!-- EMAIL TEMPLATES LIST-->

      <v-tabs slider-color="black" active-class="v-tabs_active_item" v-model="emailTemplatesTabs">
        <v-tab class="font-weight-bold" :ripple="false">Default Templates</v-tab>
        <v-tab class="font-weight-bold" :ripple="false">Custom Templates</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="emailTemplatesTabs">
        <v-tab-item>
          <v-data-table :headers="templatesHeaders"
                        :loading="dataLoading"
                        :items="preparedDefaultTemplates"
                        :search="search"
                        :footer-props="{
                          itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
                          showFirstLastPage: false,
                          prevIcon: 'fal fa-chevron-left',
                          nextIcon: 'fal fa-chevron-right',
                          itemsPerPageText: 'Templates per page'
                        }"
                        :hide-default-footer="preparedDefaultTemplates.length < 11">
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer 
                :pagination="pagination" 
                :options="options"
                :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
                :showFirstLastPage="false"
                prevIcon="fal fa-chevron-left"
                nextIcon="fal fa-chevron-right"
                @update:options="updateOptions"
                items-per-page-text="Templates per page" />
            </template>
            <template v-slot:item.id="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="green" @click="editTemplate(item)"><v-icon>edit</v-icon></v-btn>
                </template>
                <span>Edit Template</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="red" @click="confirmDeleteEmailTemplate(item)"><v-icon>clear</v-icon></v-btn>
                </template>
                <span>Remove Template</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table :headers="templatesHeaders"
                        :loading="dataLoading"
                        :items="preparedCustomTemplates"
                        :search="search"
                        :footer-props="{
                          itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
                          showFirstLastPage: false,
                          prevIcon: 'fal fa-chevron-left',
                          nextIcon: 'fal fa-chevron-right',
                          itemsPerPageText: 'Templates per page'
                        }"
                        :hide-default-footer="preparedCustomTemplates.length < 11">
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer 
                :pagination="pagination" 
                :options="options"
                :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
                :showFirstLastPage="false"
                prevIcon="fal fa-chevron-left"
                nextIcon="fal fa-chevron-right"
                @update:options="updateOptions"
                items-per-page-text="Templates per page" />
            </template>
            <template v-slot:item.id="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="green" @click="editTemplate(item)"><v-icon>edit</v-icon></v-btn>
                </template>
                <span>Edit Template</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
      <!-- END EMAIL TEMPLATES LIST-->
      <!-- ADD/EDIT EMAIL TEMPLATE DIALOG -->
      <v-dialog v-model="emailTemplateDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="blue">
            <v-toolbar-title>{{ isEdit ? 'Edit' : 'Create' }} {{ emailTemplatesTabs ? 'Custom' : 'Default' }} Email Template</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="emailTemplateDialog = false">
              <v-icon>fal fa-times</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-5">
            <v-tabs slider-color="black" active-class="v-tabs_active_item" v-model="emailTemplateEditTabs">
              <v-tab class="font-weight-bold" :ripple="false"><v-icon :color="emailTemplateEditTabs === 0 ? 'black' : 'blue'" class="mr-1">code</v-icon> Template</v-tab>
              <v-tab class="font-weight-bold" :ripple="false"><v-icon :color="emailTemplateEditTabs === 1 ? 'black' : 'blue'" class="mr-1">pageview</v-icon> Preview</v-tab>
            </v-tabs>
            <v-divider></v-divider>
            <v-tabs-items v-model="emailTemplateEditTabs">
              <v-tab-item>
                <v-form ref="emailTemplateForm">
                  <v-row>
                    <v-col cols="12" sm="5" md="4" lg="3">
                      <v-select :disabled="isEdit" :items="emailTemplatesTabs || isEdit ? templateTypes : preparedTypesDefault" :rules="[v => [2,5,7,13,15,36,37,41,48,50].indexOf(v) !== -1 || '']" item-value="type" item-text="name" v-model="emailTemplateType" label="Template type"></v-select>
                      <v-text-field v-model="emailTemplateName" label="Template Name" :rules="[v => !!v || '']"></v-text-field>
                      <v-text-field v-model="emailTemplateSubject" label="Subject" :rules="[v => !!v || '']"></v-text-field>
                      <div v-if="emailTemplateReplacements.length" class="subtitle-2">Replacements:</div>
                      <v-btn v-for="rep in emailTemplateReplacements" :key="rep" tile block depressed class="mb-1" @click="drag(rep)">{{ rep }}</v-btn>
                    </v-col>
                    <v-col cols="12" sm="7" md="8" lg="9" class="py-0">
                      <codemirror ref="codeMirror" v-model="emailTemplateCode" :options="cmOption"></codemirror>
                    </v-col>
                  </v-row>
                  <div class="text-right py-2">
                    <v-btn dark tile depressed color="blue" @click="saveEmailTemplate">Save Template</v-btn>
                  </div>
                </v-form>
              </v-tab-item>
              <v-tab-item class="py-4">
                <p v-html="emailTemplateCode"></p>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- END ADD/EDIT EMAIL TEMPLATE DIALOG -->
      <!-- REMOVE EMAIL TEMPLATE CONFIRMATION DIALOG -->
      <v-dialog v-model="deleteEmailTemplateDialog" persistent max-width="425">
        <v-card>
          <v-card-text class="body-1 pt-5">Are you sure you want to delete template <span class="whitespace-nowrap">{{templateToDelete.name}}</span>?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text @click="deleteEmailTemplateDialog = false">Close</v-btn>
            <v-btn tile dark depressed color="red" @click="deleteEmailTemplate">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END REMOVE EMAIL TEMPLATE CONFIRMATION DIALOG -->
    </div>
  </DefaultLayout>
</template>

<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/ambiance.css';
import 'codemirror/mode/xml/xml.js';
import 'codemirror/theme/base16-light.css';
import uuidv4 from 'uuid/v4';
import { mapState } from 'vuex';
import {
  GET_ACCOUNT_DEFAULT_EMAIL_TEMPLATES,
  GET_ACCOUNT_CUSTOM_EMAIL_TEMPLATES,
  GET_EMAIL_TEMPLATES_REPLACEMENTS,
  UPDATE_ACCOUNT_DEFAULT_EMAIL_TEMPLATE,
  UPDATE_ACCOUNT_CUSTOM_EMAIL_TEMPLATE,
  DELETE_ACCOUNT_DEFAULT_EMAIL_TEMPLATE,
} from '@/store/actions.type';
import DefaultLayout from '@/layouts/DefaultLayout';
import { customizableEmailTemplates } from '@/helpers/constants';

export default {
  name: 'email-templates',
  components: {
    codemirror,
    DefaultLayout,
  },
  data() {
    return {
      featureLimitedModal: false,
      featureLimitedText: '',
      featureLimitedDefaultText: 'To enable this feature, you need to upgrade your price plan.',
      emailTemplatesTabs: 0,
      isEdit: true,
      dataLoading: false,
      templatesHeaders: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Type', value: 'typeString', align: 'left' },
        { text: 'Actions', value: 'id', align: 'left', sortable: false },
      ],
      customTemplates: [],
      defaultTemplates: [],
      templatesReplacements: [],
      search: '',
      emailTemplateEditTabs: 0,
      cmOption: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        autoCloseTags: true,
        line: true,
        refresh:true,
        mode: 'text/html',
      },
      emailTemplateDialog: false,
      emailTemplateId: '',
      emailTemplateName: '',
      emailTemplateType: 0,
      emailTemplateSubject: '',
      emailTemplateReplacements: [],
      emailTemplateCode: '',
      deleteEmailTemplateDialog: false,
      templateToDelete: {name: ''},
    };
  },
  computed: {
    ...mapState({ organization: state => state.organizations.userSelectedOrganization }),
    ...mapState({ limitations: state => state.organizations.userSelectedOrganization.limitations }),
    preparedDefaultTemplates() {
      return this.filterTemplates(this.defaultTemplates);
    },
    preparedCustomTemplates() {
      return this.filterTemplates(this.customTemplates);
    },
    templateTypes() {
      const types = [];
      for (let key in customizableEmailTemplates) {
        const type = customizableEmailTemplates[key];
        type.typeString = key;
        types.push(type);
      }
      return types;
    },
    preparedTypesDefault() {
      const types = [];
      this.templateTypes.forEach(type => {
        if (this.defaultTemplates && this.defaultTemplates.find(t => t.type === type.type)) {
          return;
        }
        types.push(type);
      });
      return types;
    },
  },
  watch:{
    emailTemplateDialog() {
      this.emailTemplateEditTabs = 0;
    },
    featureLimitedModal(val) {
      if (!val) {
        this.featureLimitedText = '';
      }
    },
  },
  methods: {
    filterTemplates(templatesList) {
      const allowedTemplates = this.templateTypes.map(t => t.type);
      const preparedTemplates = [];
      if(templatesList){
        templatesList.forEach(template => {
          if (allowedTemplates.indexOf(template.type) !== -1) {
            template.replacements = [];
            const replacements = this.templatesReplacements.find(rep => rep.templateType === template.type);
            if (replacements && replacements.replacements && replacements.replacements.length) {
              replacements.replacements.forEach(rep => {
                template.replacements.push(rep)
              });
            }
            preparedTemplates.push(template);
          }
        });
      }

      preparedTemplates.forEach(el => {
        var type = this.templatesReplacements.find(x => x.templateType == el.type);
        el.typeString = type.templateName;
      });
      return preparedTemplates;
    },
    async getEmailTemplates(type) {

      // GET ALL EMAIL TEMPLATES
      if (!type) {
        this.dataLoading = true;
        try {
          const defaultTemplates = await this.$store.dispatch(GET_ACCOUNT_DEFAULT_EMAIL_TEMPLATES, this.organization.id);
          this.defaultTemplates = defaultTemplates.list;
          const customTemplates = await this.$store.dispatch(GET_ACCOUNT_CUSTOM_EMAIL_TEMPLATES, this.organization.id);
          this.customTemplates = customTemplates.list;
          this.dataLoading = false;
        } catch(err) {
          this.dataLoading = false;
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error getting email templates. Please contact support@planetverify.com',
          });
        }
        return;
      }

      // GET ONLY DEFAULT EMAIL TEMPLATES
      if (type.toLowerCase() === 'default') {
        try {
          const defaultTemplates = await this.$store.dispatch(GET_ACCOUNT_DEFAULT_EMAIL_TEMPLATES, this.organization.id);
          this.defaultTemplates = defaultTemplates.list;
          this.dataLoading = false;
        } catch(err) {
          this.dataLoading = false;
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error getting email templates. Please contact support@planetverify.com',
          });
        }
      }

      // GET ONLY CUSTOM EMAIL TEMPLATES
      if (type.toLowerCase() === 'custom') {
        try {
          const customTemplates = await this.$store.dispatch(GET_ACCOUNT_CUSTOM_EMAIL_TEMPLATES, this.organization.id);
          this.customTemplates = customTemplates.list;
          this.dataLoading = false;
        } catch(err) {
          this.dataLoading = false;
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error getting email templates. Please contact support@planetverify.com',
          });
        }
      }
    },
    async getEmailTemplatesReplacements() {
      try {
        const replacements = await this.$store.dispatch(GET_EMAIL_TEMPLATES_REPLACEMENTS);
        this.templatesReplacements = replacements.list;
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting email templates replacements. Please contact support@planetverify.com',
        });
      }
    },
    drag(replacement) {
      this.$refs.codeMirror.codemirror.replaceSelection(`{{${replacement}}}`);
    },
    addTemplate() {
      if (!this.emailTemplatesTabs && !this.preparedTypesDefault.length) {
        this.$notify({
          type: 'warn',
          title: 'Error',
          text: 'All default email templates are created. Please edit existing one.',
        });
        return;
      }
      // if ((!this.limitations.E_AccountDefaultEmails && !this.emailTemplatesTabs) || (!this.limitations.E_AccountCustomEmails && this.emailTemplatesTabs)) {
      //   this.featureLimitedModal = true;
      //   return;
      // }
      this.isEdit = false;
      this.emailTemplateId = uuidv4();
      this.emailTemplateName = '';
      this.emailTemplateType = 0;
      this.emailTemplateSubject = '';
      this.emailTemplateReplacements = '';
      this.emailTemplateCode = '';
      this.emailTemplateDialog = true;
    },
    editTemplate(item) {
      // if ((!this.limitations.E_AccountDefaultEmails && !this.emailTemplatesTabs) || (!this.limitations.E_AccountCustomEmails && this.emailTemplatesTabs)) {
      //   this.featureLimitedModal = true;
      //   return;
      // }
      this.isEdit = true;
      this.emailTemplateId = item.id;
      this.emailTemplateName = item.name;
      this.emailTemplateType = item.type;
      this.emailTemplateSubject = item.subject;
      this.emailTemplateCode = item.body;
      this.emailTemplateReplacements = item.replacements;
      this.emailTemplateDialog = true;
    },
    confirmDeleteEmailTemplate(item) {
      this.templateToDelete = item;
      this.deleteEmailTemplateDialog = true;
    },
    async deleteEmailTemplate() {
      try {
        await this.$store.dispatch(DELETE_ACCOUNT_DEFAULT_EMAIL_TEMPLATE, this.templateToDelete);
        this.deleteEmailTemplateDialog = false;
        await this.getEmailTemplates('default');
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error deleting email template. Please contact support@planetverify.com',
        });
      }
    },
    async saveEmailTemplate() {
      if (!this.$refs.emailTemplateForm.validate()) {
        return;
      }
      const template = {
        id: this.emailTemplateId,
        accountId: this.organization.id,
        type: this.emailTemplateType,
        name: this.emailTemplateName,
        subject: this.emailTemplateSubject,
        body: this.emailTemplateCode,
      };
      try {
        if (this.emailTemplatesTabs) {
          await this.$store.dispatch(UPDATE_ACCOUNT_CUSTOM_EMAIL_TEMPLATE, template);
          await this.getEmailTemplates('custom');
        } else {
          await this.$store.dispatch(UPDATE_ACCOUNT_DEFAULT_EMAIL_TEMPLATE, template);
          await this.getEmailTemplates('default');
        }
        this.emailTemplateDialog = false;
        this.$notify({
          type: 'success',
          title: 'Success',
          text: this.isEdit ? 'Email template updated' : 'Email template created',
        });
      } catch(err) {
        this.emailTemplateDialog = false;
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: this.isEdit ? 'Error updating email template. Please contact support@planetverify.com' : 'Error creating email template. Please contact support@planetverify.com',
        });
      }
    },
  },
  async mounted() {
    await this.getEmailTemplatesReplacements();
    await this.getEmailTemplates();
  },
}
</script>

<style>
.CodeMirror {
  height: 600px;
  font-size: 12px;
}
</style>
